module.exports = __webpack_public_path__ + "img/检查.42ff3c51.svg";